import { css, CSSResult } from 'lit'
import { csColorBorder, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cseLoader = {
  animationName: css`var(--cse-loader-animation-name, rotate)`,
  animationDuration: css`var(--cse-loader-animation-duration, 2s)`,
  color: css`var(--cse-loader-color, ${csColorText.body})`,
  spinnerBackgroundColor: css`var(--cse-spinner-background-color, ${csColorBorder.medium})`,
  spinnerForegroundColor: css`var(--cse-spinner-foreground-color, ${csColorText.body})`,
  spinnerSize: css`var(--cse-spinner-size, ${csSpacing.spacing10})`
}

export const style: CSSResult = css`
  .cse-loader {
    color: ${cseLoader.color};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .animated {
    display: inline-flex;
    animation-name: ${cseLoader.animationName};
    animation-duration: ${cseLoader.animationDuration};
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(359deg);
    }
  }

  .spinner svg {
    display: block;
    width: ${cseLoader.spinnerSize};
    height: ${cseLoader.spinnerSize};
  }
  .spinner .spinner-background {
    stroke: ${cseLoader.spinnerBackgroundColor};
    opacity: 1;
  }
  .spinner .spinner-foreground {
    stroke: ${cseLoader.spinnerForegroundColor};
    stroke-dasharray: 31.4 94.2; /* 25% arc, 75% gap */
    stroke-dashoffset: 0;
    transform: rotate(0deg);
    transform-origin: 50% 50%;
    animation: spinner-spin 1.4s linear infinite;
  }
  @keyframes spinner-spin {
    100% { transform: rotate(360deg); }
  }
`
